// ==============================|| CETĂȚEAN - DETALIU - EXTRAS ||============================== //
// Câmpuri suplimentare pe care `IAppUser` nu le acoperă încă (abonamente, proiecte abonate,
// semnale de afinitate). Până când BE le livrează, se folosește `EMPTY_EXTRAS`, iar interfața
// afișează fallback-uri („—" / liste goale). Istoricul de locații GPS vine acum REAL din BE
// (GET api/users/:id/geolocations — vezi useUserGeolocations), nu din acest mock.

interface IHeatItem {
	nume: string;
	scor: number; // 0–100
}

type AbonamentNivel = 'local' | 'judetean' | 'national';

interface ICitizenAbonament {
	tip: AbonamentNivel;
	nume: string;
}

interface INamedRef {
	id: string;
	nume: string;
}

interface ICitizenAfinitati {
	proiecteVizualizate: IHeatItem[];
	uatFrecvente: IHeatItem[];
	categoriiFrecvente: IHeatItem[];
	administratiiFrecvente: IHeatItem[];
	zoneFrecvente: IHeatItem[];
	proiecteInteractionate: INamedRef[];
	anunturiVizualizate: INamedRef[];
}

export interface ICitizenDetailExtras {
	cartier?: string;
	abonamente: ICitizenAbonament[];
	proiecteAbonate: INamedRef[];
	afinitati: ICitizenAfinitati;
}

export const EMPTY_EXTRAS: ICitizenDetailExtras = {
	abonamente: [],
	proiecteAbonate: [],
	afinitati: {
		proiecteVizualizate: [],
		uatFrecvente: [],
		categoriiFrecvente: [],
		administratiiFrecvente: [],
		zoneFrecvente: [],
		proiecteInteractionate: [],
		anunturiVizualizate: []
	}
};
